import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTakeSourceLinesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrderLineItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrderLineItemDocumentSortInput> | Types.OrderLineItemDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetTakeSourceLinesQuery = { __typename?: 'Query', orderLineItems?: { __typename?: 'OrderLineItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrderLineItemDocument', acknowledgedQuantity?: number | null, lineItemId: string, orderId: string, orderedQuantity?: number | null, quantity?: number | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetTakeSourceLinesDocument = new TypedDocumentString(`
    query GetTakeSourceLines($where: OrderLineItemDocumentFilterInput, $order: [OrderLineItemDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orderLineItems(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      acknowledgedQuantity
      lineItemId
      orderId
      orderedQuantity
      quantity
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTakeSourceLines: build.query<GetTakeSourceLinesQuery, GetTakeSourceLinesQueryVariables | void>({
      query: (variables) => ({ document: GetTakeSourceLinesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTakeSourceLinesQuery, useLazyGetTakeSourceLinesQuery } = injectedRtkApi;
